import React from 'react';
import { styled } from 'linaria/react';
import { Section, SectionSubTitle } from 'common/components';
import { createElementKey } from 'utils';
import { SeasonStartCategory, SeasonStartCategoryStructure } from '../season-start-category';

type SeasonStartCategoriesProps = {
  categoryList: SeasonStartCategoryStructure[];
  elementBlock: string;
  title?: string;
}

export const SeasonStartCategoriesContainer = styled.div`
  display: flex;
  gap: 32px;

  @media (--to-desktop) {
    flex-direction: column;
  }

  @media (--only-mobile) {
    row-gap: 24px;
  }

  > div {
    @media (--from-desktop) {
      width: 50%;
    }
  }
`;

export const SeasonStartCategories: React.FC<SeasonStartCategoriesProps> = ({ categoryList, elementBlock, title }) => (
  <Section>
    {title && (
      <SectionSubTitle margin="m" variant="h2">
        {title}
      </SectionSubTitle>
    )}
    <SeasonStartCategoriesContainer>
      {categoryList.map((category, index) => (
        <SeasonStartCategory
          category={category}
          elementBlock={elementBlock}
          key={createElementKey('season-start-category', index)}
        />
      ))}
    </SeasonStartCategoriesContainer>
  </Section >
);
